import typeToReducer from 'type-to-reducer';

import * as actions from './actions';

const initialState = {
  mobileNavVisible: false,
  sidebarVisible: false,
  updateSubscriptionModalVisible: false,
  notification: {
    id: 0,
    description: '',
    duration: 0,
    title: '',
    type: '',
  },
};

export default typeToReducer(
  {
    [actions.TOGGLE_SIDEBAR]: (state) => ({
      ...state,
      sidebarVisible: !state.sidebarVisible,
    }),
    [actions.SHOW_SIDEBAR]: (state) => ({
      ...state,
      sidebarVisible: true,
    }),
    [actions.HIDE_SIDEBAR]: (state) => ({
      ...state,
      sidebarVisible: false,
    }),

    [actions.SHOW_MOBILE_NAV]: (state) => ({
      ...state,
      mobileNavVisible: true,
    }),
    [actions.HIDE_MOBILE_NAV]: (state) => ({
      ...state,
      mobileNavVisible: false,
    }),

    [actions.SHOW_UPDATE_SUBSCRIPTION_MODAL]: (state) => ({
      ...state,
      updateSubscriptionModalVisible: true,
    }),
    [actions.HIDE_UPDATE_SUBSCRIPTION_MODAL]: (state) => ({
      ...state,
      updateSubscriptionModalVisible: false,
    }),

    [actions.PUSH_NOTIFICATION]: (state, action) => {
      const { description, duration, title, type } = action.payload;
      const id = new Date().getTime();

      return {
        ...state,
        notification: {
          id,
          description,
          duration,
          title,
          type,
        },
      };
    },
  },
  initialState,
);
